import { Box, Heading, ListItem, OrderedList } from '@hover/blueprint';
import React from 'react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { useLocation } from '@reach/router';
import { TERMS_OF_USE_TABLE_OF_CONTENT_OLD } from '../../constants';

const TermsOfUseTableOfContentOld: React.FC = () => {
  const location = useLocation();

  const hyphenMode = location.pathname.includes('/terms-of-use');
  return (
    <Box flexDir="column" mb={{ base: 600, tablet: '56px' }}>
      <Heading as="h2" size={500} fontWeight={400} marginBottom={500}>
        Table of content
      </Heading>
      <OrderedList ml={0}>
        {TERMS_OF_USE_TABLE_OF_CONTENT_OLD.map(link => (
          <ListItem key={link.label} color="primary.600" fontWeight={600}>
            <AnchorLink
              to={hyphenMode ? link.to.replaceAll('_', '-') : link.label}
              stripHash
            >
              {link.label}
            </AnchorLink>
          </ListItem>
        ))}
      </OrderedList>
    </Box>
  );
};

export default TermsOfUseTableOfContentOld;
